import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, InjectionToken } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { HttpModule } from '@angular/http';
import { CustomHttp } from './shared/custom.http';


import { AppComponent } from './app.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
// Routing Module
import { AppRoutingModule } from './app.routing';
// Layouts
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
// tslint:disable-next-line:comment-format
//Parrots
import { InternalUserComponent } from './user/internaluser.component';
import { UserCreateComponent } from './user/user-create.component';
import { UserDetailComponent } from './user/user-detail.component';
import { DatepickerModule, BsDatepickerModule, CollapseModule } from 'ngx-bootstrap';

import { ClickOutsideModule } from 'ng-click-outside';

import { AuthService } from './login/login.service';

import { UserService } from './user/user.service';
// tslint:disable-next-line:comment-format
//3rd party library
import { SimpleNotificationsModule } from 'angular2-notifications';
import { ModalModule } from 'ngx-modialog';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';


import { EqualValidator } from './shared/widgets/equal-validator.directive';
// tslint:disable-next-line:comment-format
//TMS
import { TmsLandingpageComponent } from './tms/tms-landingpage.component';
import { TitleCreateComponent } from './tms/title-create.component';
import { TitleService } from './tms/title.service';
import { EventlogService } from './tms/eventlog.service';
import { TitleRequestService } from './tms/titleRequest.service';
import { RemoveCharPipe } from './tms/remove-char-pipe';

// tslint:disable-next-line:comment-format
//Catalog API
import { CatalogService } from './catalogue/catalog-api/catalog.service';
// tslint:disable-next-line:comment-format
//Data Anamoly
import { DataAnamolyComponent } from './catalogue/dataanamoly/dataanamoly.component';
import { DataAnamolyComponent1 } from './catalogue/dataanamoly/dataanamoly.component.1';

import { DataAnamolyService } from './catalogue/dataanamoly/dataanamoly.service';
import { DipDetectionService } from './catalogue/dipdetection/dipdetection.service';
import { DipDetectionComponent } from './catalogue/dipdetection/dipdetection.component';
import { DipDetectionComponent1 } from './catalogue/dipdetection/dipdetection.component.1';

import { DashboardComponent } from './dashboard/dashboard.component';

import { GlobalTrendsComponent } from './globaltrends/globaltrends.component';
import { GlobalTrendsService } from './globaltrends/globaltrends.service';

import { SharedModule } from './shared/shared.module';
import { CatalogModule } from './catalogue/catalog.module';
import { Portalv1Module } from './portalv1/portalv1.module';
import { Ng2CompleterModule } from 'ng2-completer';
import { ToasterModule } from 'angular2-toaster';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfigService } from './shared/config.service';
import { BulkInfohashService } from './bulk-infohash/bulk-infohash.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { UserDetailsService } from './shared/user.details.service';
import { StatisticsComponent } from './statistics/statistics.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { InAppNotificationsService } from './notifications/notifications.service';
import { ApiConstants } from './shared';
import { GeneralConstants } from './shared/general.constants';
import { AddToAccountModalService } from './catalogue/add-to-acount-modal/add-to-account-modal.service';
import {HighlightPipe} from './shared/highlight.pipe';
import {VideoModule} from './youtube-video/video.module';
import {VideoService} from './youtube-video/model/video.service';
import {ClipboardModule} from 'ngx-clipboard';
import {AuthGuard} from './guard/auth.guard';
import {BulkInfohashV2Service} from './bulkinfohash-v2/model/bulk-infohash-v2.service';
import {BulkInfohashV2Module} from './bulkinfohash-v2/bulk-infohash-v2.module';
import {ESDashboardService} from './elastic-search-dashboard/esDashboard.service';
import {EsDashboardModule} from './elastic-search-dashboard/esDashboard.module';


export function configFactory(configService: ConfigService) {
    return () => configService.load();
}

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        TabsModule.forRoot(),
        ChartsModule,
        ClipboardModule,
        FormsModule,
        HttpModule,
        DatepickerModule.forRoot(),
        BsDatepickerModule.forRoot(),
        ModalModule.forRoot(),
        BootstrapModalModule,
        SimpleNotificationsModule.forRoot(),
        SharedModule,
        CatalogModule, VideoModule, BulkInfohashV2Module, EsDashboardModule,
        Portalv1Module,
        Ng2CompleterModule,
        ClickOutsideModule,
        BrowserAnimationsModule,
        ToasterModule.forRoot(),
        TooltipModule.forRoot(),
        CollapseModule.forRoot(),
        CatalogModule
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        NAV_DROPDOWN_DIRECTIVES,
        SIDEBAR_TOGGLE_DIRECTIVES,
        LoginComponent,

        // tslint:disable-next-line:comment-format
        //Equal
        EqualValidator,

        // tslint:disable-next-line:comment-format
        //Parrots
        InternalUserComponent,
        UserCreateComponent,
        UserDetailComponent,

        // tslint:disable-next-line:comment-format
        //TMS
        TmsLandingpageComponent,
        TitleCreateComponent,
        RemoveCharPipe,

        // tslint:disable-next-line:comment-format
        //Data Anamoly
        DataAnamolyComponent,
        DataAnamolyComponent1,
        DashboardComponent,

        DipDetectionComponent,
        DipDetectionComponent1,

        GlobalTrendsComponent,


        StatisticsComponent,
        NotificationsComponent
    ],
    providers: [
        AuthGuard,
        UserService,
        AuthService,
        CatalogService,
        VideoService,
        ESDashboardService,
        BulkInfohashV2Service,
        CustomHttp,
        DataAnamolyService,
        DipDetectionService,
        GlobalTrendsService,
        BulkInfohashService,
        InAppNotificationsService,
        AddToAccountModalService,
        // tslint:disable-next-line:comment-format
        //TMS
        TitleService,
        EventlogService,
        TitleRequestService,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: configFactory,
            deps: [ConfigService],
            multi: true
        },
        ApiConstants,
        GeneralConstants,
        UserDetailsService],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts